import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDocument, PmsDocument } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDocument>
    useData={usePmsDocument}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
